export const workspaceDashboard = () => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('workspace-dashboard.open-share-drawer', () => {
        digitalData.event = digitalData.event || [];
        digitalData.event.push({
            category: {
                primaryCategory: 'overlay',
            },
            eventInfo: {
                eventName: 'workspace dashboard lists: email list',
            },
        });
    });

    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('workspace-dashboard.email-list', () => {
        digitalData.event = digitalData.event || [];
        digitalData.event.push({
            category: {
                primaryCategory: 'button submission',
            },
            eventInfo: {
                eventName: 'my account settings',
            },
            myAccount: {
                settings: 'homepage: workspace dashboard: share list: email',
            },
        });
    });
};
